import { render, staticRenderFns } from "./spareGetDetailUpdate.vue?vue&type=template&id=24fccb5c&scoped=true"
import script from "./spareGetDetailUpdate.vue?vue&type=script&lang=js"
export * from "./spareGetDetailUpdate.vue?vue&type=script&lang=js"
import style0 from "./spareGetDetailUpdate.vue?vue&type=style&index=0&id=24fccb5c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24fccb5c",
  null
  
)

export default component.exports